import { AlertCircle, X } from 'lucide-react';
import { useState } from 'react';

interface PaymentWarningBannerProps {
  message: string;
  paymentDueDate?: string;
  onDismiss?: () => void;
  variant?: 'warning' | 'error';
}

export default function PaymentWarningBanner({
  message,
  paymentDueDate,
  onDismiss,
  variant = 'warning',
}: PaymentWarningBannerProps) {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    onDismiss?.();
  };

  const bgColor = variant === 'error' ? 'bg-destructive/10' : 'bg-warning/10';
  const borderColor = variant === 'error' ? 'border-destructive/20' : 'border-warning/20';
  const textColor = variant === 'error' ? 'text-destructive' : 'text-warning-foreground';

  return (
    <div className={`${bgColor} ${borderColor} border rounded-lg p-4 mb-6 flex items-start gap-3`}>
      <AlertCircle className={`w-5 h-5 ${textColor} flex-shrink-0 mt-0.5`} />
      <div className="flex-1">
        <p className={`text-sm font-medium ${textColor} mb-1`}>
          {message}
        </p>
        {paymentDueDate && (
          <p className="text-xs text-muted-foreground">
            Payment due: {new Date(paymentDueDate).toLocaleDateString()}
          </p>
        )}
        <p className="text-xs text-muted-foreground mt-2">
          You are in view-only mode. Please complete payment to restore full access.
        </p>
      </div>
      {onDismiss && (
        <button
          onClick={handleDismiss}
          className="text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}

